<script setup>
import algoliasearch from "algoliasearch/lite"
import { AisInstantSearch, AisConfigure, AisSearchBox } from "vue-instantsearch/vue3/es"
import { Panel } from "@/Components/Algolia"
import { apiKey, appId } from "@/Search/utils"
import RangeInput from "@/Components/Algolia/RangeInput.vue"
import RefinementList from "@/Components/Algolia/RefinementList.vue"

const props = defineProps({
  items: {
    type: Array,
    default: [],
  },
  limit: {
    type: Number,
    default: 32
  },
  defaultIndex: {
    type: String,
    required: true,
  },
  variantFilters: {
    type: Object,
    default: {
      toggleRefinements: [],
      refinementLists: [],
      ranges: []
    }
  }
})
const searchClient = algoliasearch(appId, apiKey)
</script>

<template>
  <div class="md:flex">
    <div class="w-full md:w-1/4 relative">
      <div class="bg-black/5 absolute w-full h-full justify-center flex">
        <span class="bg-black/50 text-white p-2 font-medium absolute mt-4 rounded-full">
          {{ __('Display only') }}
        </span>
      </div>

      <AisInstantSearch
        ref="instantSearchWrapper"
        :index-name="defaultIndex"
        :initial-ui-state="{}"
        :search-client="searchClient"
      >
        <div class="flex h-full">
          <div class="w-full p-2 h-full space-y-2 max-h-full">
            <AisConfigure :hitsPerPage="limit" />

            <Panel>
              <template #header>
                {{ __('Keywords') }}
              </template>

              <AisSearchBox>
                <template v-slot="{ currentRefinement, isSearchStalled, refine }">
                  <input
                    type="search"
                    class="mt-1 block w-full rounded-md border px-3 py-2 shadow-sm transition duration-150 ease-in-out focus:border-primary-300 focus:ring-primary-200/50 sm:text-sm border-gray-300">
                </template>
              </AisSearchBox>
            </Panel>

            <div>
              <Panel>
                <template #header>
                  {{ __('Price') }}
                </template>
                <RangeInput attribute="price" />
              </Panel>
            </div>

            <Panel>
              <template #header>
                {{ __('Product Type') }}
              </template>
              <RefinementList attribute="type" />
            </Panel>

            <Panel>
              <template #header>
                {{ __('Listing Type Tier') }}
              </template>
              <RefinementList attribute="listing_type_tier" />
            </Panel>

            <Panel>
              <template #header>
                {{ __('Weight') }} (carats)
              </template>
              <RangeInput attribute="weight" />
            </Panel>

            <Panel v-for="variant in variantFilters.refinementLists">
              <template #header>
                {{ variant.label }}
              </template>
              <RefinementList
                :attribute="variant.attribute"
              />
            </Panel>

            <Panel>
              <template #header>
                {{ __('Length') }} (mm)
              </template>
              <RangeInput attribute="length" />
            </Panel>

            <Panel>
              <template #header>
                {{ __('Width') }} (mm)
              </template>
              <RangeInput attribute="width" />
            </Panel>

            <Panel>
              <template #header>
                {{ __('Depth') }} (mm)
              </template>
              <RangeInput attribute="depth" />
            </Panel>

            <Panel v-for="variant in variantFilters.ranges">
              <template #header>
                {{ variant.label }}
              </template>
              <RangeInput :attribute="variant.attribute" :precision="variant.precision" />
            </Panel>
          </div>
        </div>
      </AisInstantSearch>
    </div>

    <div class="w-full md:w-3/4 p-4">
      <slot name="auctions" />
    </div>
  </div>
</template>
